"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.VALID_SIZES = exports.ButtonLink = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var React = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _constants = require("../constants");
var _valueMap = _interopRequireDefault(require("../utils/valueMap"));
var _loading_spinner = _interopRequireDefault(require("./loading_spinner"));
var _polished = require("polished");
var _theme = require("../../birch/components/buttons/theme");
var _templateObject, _templateObject2, _templateObject3, _templateObject4;
var _excluded = ["children"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); } // @ts-expect-error - TS7016 - Could not find a declaration file for module './loading_spinner'. 'src/azalea/components/loading_spinner.js' implicitly has an 'any' type.
var VALID_SIZES = exports.VALID_SIZES = ['small', 'default', 'large', 'xlarge'];
// @ts-expect-error - TS2345 - Argument of type 'readonly ["small", "default", "large", "xlarge"]' is not assignable to parameter of type 'string[]'.
var size = (0, _valueMap["default"])(VALID_SIZES, 'size');
var birchTertiaryStyling = function birchTertiaryStyling(theme) {
  return "\n  &&&& {\n    color: ".concat(theme["default"].color, ";\n\n    &:hover, &:focus  {\n      color: ").concat(theme.hover.color, ";\n    }\n  }\n");
};
var birchStyling = function birchStyling(theme) {
  return "\n  &&&& {\n    color: ".concat(theme["default"].color, ";\n    background: ").concat(theme["default"].backgroundColor, ";\n    border-color: ").concat(theme["default"].borderColor, ";\n    svg path {\n      fill: ").concat(theme["default"].color, ";\n    }\n\n    &:hover, &:focus  {\n      color: ").concat(theme.hover.color, ";\n      background: ").concat(theme.hover.backgroundColor, ";\n      border-color: ").concat(theme.hover.borderColor, ";\n      svg path {\n        fill: ").concat(theme.hover.color, ";\n      }\n    }\n\n    &:active {\n      background: ").concat(theme.active.backgroundColor, ";\n      border-color: ").concat(theme.active.borderColor, ";\n      color: ").concat(theme.active.color, ";\n    }\n\n    border-radius: 8px;\n\n    font-weight: 400;\n\n    box-shadow: 0px 2px 5px -1px ").concat(theme["default"].dropShadowColor, ";\n  }\n");
};
var Button = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(Button, _React$Component);
  var _super = _createSuper(Button);
  function Button() {
    var _this;
    (0, _classCallCheck2["default"])(this, Button);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "flavor", function () {
      if (_this.props.fancy) {
        return 'fancy';
      } else if (_this.props.hideBg) {
        return _this.props.removeHideBgPadding ? 'hideBgNoPadding' : 'hideBg';
      } else if (_this.props.danger) {
        return 'danger';
      } else {
        return 'default';
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "tag", function () {
      if (_this.props.useButtonTag) {
        return 'button';
      } else {
        return 'a';
      }
    });
    return _this;
  }
  (0, _createClass2["default"])(Button, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        children = _this$props.children,
        others = (0, _objectWithoutProperties2["default"])(_this$props, _excluded);
      var ButtonClassType = birchButtonsByFlavor[this.flavor()][this.tag()];
      return (
        /*#__PURE__*/
        // @ts-expect-error - TS2339 - Complex case where button can be either a button or a link.
        React.createElement(ButtonClassType, (0, _extends2["default"])({
          role: this.props.href ? undefined : 'button',
          tabIndex: 0,
          disabled: this.props.disabled,
          "aria-disabled": this.props.disabled
        }, others), this.props.loading && /*#__PURE__*/React.createElement(AlignedLoadingSpinner, {
          size: "small",
          flavor: loadingSpinnerColor(this.flavor(), this.props.hideBg)
        }), children)
      );
    }
  }]);
  return Button;
}(React.Component);
(0, _defineProperty2["default"])(Button, "defaultProps", {
  onClick: function onClick() {},
  size: 'default'
});
var AlignedLoadingSpinner = (0, _styledComponents["default"])(_loading_spinner["default"]).withConfig({
  displayName: "button__AlignedLoadingSpinner"
})(["vertical-align:bottom;margin-right:5px;margin-top:-2px;margin-bottom:-2px;"]);
function loadingSpinnerColor(flavor, hideBg) {
  if (flavor === 'default') return 'doubleGreen';else if (hideBg) return 'blue';
  return 'pale';
}
var ButtonLink = exports.ButtonLink = _styledComponents["default"].a.attrs(function (props) {
  return {
    role: props.href ? undefined : 'button',
    disabled: props.disabled,
    'aria-disabled': props.disabled
  };
}).withConfig({
  displayName: "button__ButtonLink"
})(["box-sizing:border-box;position:relative;", " display:inline-block;line-height:1;", " background:", ";border:solid 1px ", ";color:", ";&:hover{text-decoration:none;background:", ";border-color:", ";}", " ", " ", " ", " ", " ", " border-radius:", ";font-size:14px;text-align:center;text-decoration:none;cursor:pointer;user-select:none;transition:background 0.15s,border-color 0.15s;&:active{box-shadow:inset 0 1px 2px rgba(0,0,0,0.15);}"], (0, _constants.fontWeight)('heavy'), function (props) {
  return props.disabled && " opacity: 0.5;\n      pointer-events: none;\n    ";
}, _constants.colors.lightestGrey, _constants.colors.lightGrey, _constants.colors.darkestGrey, (0, _polished.darken)(0.03, _constants.colors.lightestGrey), (0, _polished.darken)(0.03, _constants.colors.lightGrey), size["default"](_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["padding: 10px 22px;"]))), size.small(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["padding: 5px 18px;"]))), size.large(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["padding: 15px 22px;"]))), size.xlarge(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2["default"])(["padding: 15px 70px;"]))), function (props) {
  return (
    // @ts-expect-error - TS2339 - Property 'block' does not exist on type 'ThemedStyledProps<Pick<DetailedHTMLProps<AnchorHTMLAttributes<HTMLAnchorElement>, HTMLAnchorElement>, "key" | keyof AnchorHTMLAttributes<...>> & { ...; } & { ...; }, DefaultTheme>'.
    props.block && " display: block;\n      width: 100%;\n    "
  );
}, /* @ts-expect-error Flow -> TS migration */'', function (props) {
  return props.rounded ? '20px' : '2px';
});
var ButtonButton = (0, _styledComponents["default"])(ButtonLink).attrs({
  as: 'button'
}).withConfig({
  displayName: "button__ButtonButton"
})([""]);
var fancy = "\n  &&&& {\n    background: ".concat(_constants.colors.mediumGreenhouseGreen, ";\n    color: ").concat(_constants.colors.white, ";\n    border-color: ").concat(_constants.colors.mediumGreenhouseGreen, ";\n\n    &:hover {\n      background: ").concat((0, _polished.darken)(0.1, _constants.colors.mediumGreenhouseGreen), ";\n      border-color: ").concat((0, _polished.darken)(0.1, _constants.colors.mediumGreenhouseGreen), ";\n      color: ").concat(_constants.colors.white, ";\n    }\n\n    &[disabled] {\n      opacity: 0.5;\n    }\n  }\n");
var FancyLink = (0, _styledComponents["default"])(ButtonLink).withConfig({
  displayName: "button__FancyLink"
})(["", ""], fancy);
var FancyButton = (0, _styledComponents["default"])(ButtonButton).withConfig({
  displayName: "button__FancyButton"
})(["", ""], fancy);
var hideBg = "\n  background: none;\n  border: none;\n  transition: none;\n  color: ".concat(_constants.colors.mediumBlue, ";\n  ").concat((0, _constants.fontWeight)('normal'), "\n\n  &:active {\n    box-shadow: none;\n  }\n\n  &:hover {\n    background: none;\n    text-decoration: underline;\n    border: none;\n  }\n");
var hideBgNoPadding = "\n  padding: 10px 0;\n  ".concat(hideBg, "\n");
var HideBgButton = (0, _styledComponents["default"])(ButtonButton).withConfig({
  displayName: "button__HideBgButton"
})(["", ""], hideBg);
var HideBgLink = (0, _styledComponents["default"])(ButtonLink).withConfig({
  displayName: "button__HideBgLink"
})(["", ""], hideBg);
var HideBgButtonNoPadding = (0, _styledComponents["default"])(ButtonButton).withConfig({
  displayName: "button__HideBgButtonNoPadding"
})(["", ""], hideBgNoPadding);
var HideBgLinkNoPadding = (0, _styledComponents["default"])(ButtonLink).withConfig({
  displayName: "button__HideBgLinkNoPadding"
})(["", ""], hideBgNoPadding);

// jQueryUI modals have very specific styles that end up changing the color of danger buttons
// The '&&&&' lets the component styles take precedence
var danger = "\n  &&&& {\n    color: white;\n    background-color: ".concat(_constants.colors.darkRed, ";\n    border-color: ").concat(_constants.colors.darkRed, ";\n\n    &:hover {\n      background: ").concat((0, _polished.darken)(0.1, _constants.colors.darkRed), ";\n      border-color: ").concat((0, _polished.darken)(0.1, _constants.colors.darkRed), ";\n    }\n  }\n");
var DangerButton = (0, _styledComponents["default"])(ButtonButton).withConfig({
  displayName: "button__DangerButton"
})(["", ""], danger);
var DangerLink = (0, _styledComponents["default"])(ButtonLink).withConfig({
  displayName: "button__DangerLink"
})(["", ""], danger);
var birchButtonsByFlavor = {
  "default": {
    a: (0, _styledComponents["default"])(ButtonLink).withConfig({
      displayName: "button__a"
    })(["", ""], birchStyling(_theme.SecondaryButtonTheme)),
    button: (0, _styledComponents["default"])(ButtonButton).withConfig({
      displayName: "button"
    })(["", ""], birchStyling(_theme.SecondaryButtonTheme))
  },
  fancy: {
    a: (0, _styledComponents["default"])(FancyLink).withConfig({
      displayName: "button__a"
    })(["", ""], birchStyling(_theme.PrimaryButtonTheme)),
    button: (0, _styledComponents["default"])(FancyButton).withConfig({
      displayName: "button"
    })(["", ""], birchStyling(_theme.PrimaryButtonTheme))
  },
  hideBg: {
    a: (0, _styledComponents["default"])(HideBgLink).withConfig({
      displayName: "button__a"
    })(["", ""], birchTertiaryStyling(_theme.TertiaryButtonTheme)),
    button: (0, _styledComponents["default"])(HideBgButton).withConfig({
      displayName: "button"
    })(["", ""], birchTertiaryStyling(_theme.TertiaryButtonTheme))
  },
  hideBgNoPadding: {
    a: (0, _styledComponents["default"])(HideBgLinkNoPadding).withConfig({
      displayName: "button__a"
    })(["", ""], birchTertiaryStyling(_theme.TertiaryButtonTheme)),
    button: (0, _styledComponents["default"])(HideBgButtonNoPadding).withConfig({
      displayName: "button"
    })(["", ""], birchTertiaryStyling(_theme.TertiaryButtonTheme))
  },
  danger: {
    a: (0, _styledComponents["default"])(DangerLink).withConfig({
      displayName: "button__a"
    })(["", ""], birchStyling(_theme.DangerButtonTheme)),
    button: (0, _styledComponents["default"])(DangerButton).withConfig({
      displayName: "button"
    })(["", ""], birchStyling(_theme.DangerButtonTheme))
  }
};
var _default = exports["default"] = Button;